import { AchPaymentDraft } from '@treasury/domain/backoffice/types/ach';
import { string } from '@treasury/FDL';
import { FdlFieldDefinitions } from '@treasury/FDL/record';
import { OmegaColumnDefinition } from '@treasury/omega/components/table';
import fieldTypes from '@treasury/policy/primitives';
import { format } from 'date-fns';

export const getAchPaymentDraftFieldDefinitions = (): FdlFieldDefinitions<AchPaymentDraft> => ({
    batchName: string.with.label('Batch Name').thatIs.readOnly(),
    achCompanyName: string.with.label('ACH Company Name').thatIs.readOnly(),
    secCode: string.with.label('SEC Code').thatIs.readOnly(),
    totalDebit: fieldTypes.money.with.label('Total Debits').thatIs.readOnly(),
    totalCredit: fieldTypes.money.with.label('Total Credits').thatIs.readOnly(),
    effectiveDate: string.with
        .label('Effective Date')
        .thatIs.readOnly()
        .and.template<string>(effectiveDate => {
            return format(effectiveDate, 'MM/dd/yyyy');
        }),
    offsetAccountNumber: string.with.label('Offset Account').thatIs.readOnly(),
});

export const getAchPaymentDraftColumns = (): OmegaColumnDefinition<AchPaymentDraft>[] => [
    {
        label: 'Batch Name',
        field: 'batchName',
    },
    {
        label: 'ACH Company Name',
        field: 'achCompanyName',
    },
    {
        label: 'SEC Code',
        field: 'secCode',
    },
    {
        label: 'Total Debits',
        field: 'totalDebit',
    },
    {
        label: 'Total Credits',
        field: 'totalCredit',
    },
    {
        label: 'Effective Date',
        field: 'effectiveDate',
    },
    {
        label: 'Offset Account',
        field: 'offsetAccountNumber',
    },
];
